module.exports = __webpack_public_path__ + "img/matrix-integrations-en-ca.49f01e04.jpg";